import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, ListGroup, Row, Table } from 'react-bootstrap';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { serviceGetAsistenciasPreliminares, serviceGetAbogadosDefensaPenal, servicePostAsignaAbogado } from '../../../api/api-asigna-abogado';
import Mensajes from '../../mensajes';

const ROL_ABOGADOS_DEFENSA_PENAL = '70ABODEFPEN';

const normaliza = (value) => (typeof value === 'string' ? value.trim().toUpperCase() : '');

const sumarDiasISO = (isoDate, dias) => {
    if (!isoDate) return '—';
    const fecha = new Date(`${isoDate}T00:00:00`);
    fecha.setDate(fecha.getDate() + dias);
    const y = fecha.getFullYear();
    const m = String(fecha.getMonth() + 1).padStart(2, '0');
    const d = String(fecha.getDate()).padStart(2, '0');
    return `${d}/${m}/${y}`;
};

// Se leen los componentes UTC del ISO (no los locales del navegador): la hora ya
// viene en la zona horaria con la que el backend armó el DATETIME (America/Bogota),
// convertir a hora local del navegador la desplazaría.
const formatearFechaHora = (isoDateTime) => {
    if (!isoDateTime) return '—';
    const fecha = new Date(isoDateTime);
    if (Number.isNaN(fecha.getTime())) return isoDateTime;
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(fecha.getUTCDate())}/${pad(fecha.getUTCMonth() + 1)}/${fecha.getUTCFullYear()} ${pad(fecha.getUTCHours())}:${pad(fecha.getUTCMinutes())}:${pad(fecha.getUTCSeconds())}`;
};

const thAsistenciasStyle = { backgroundColor: '#4F517A', color: 'white' };

const sectionHeaderStyle = {
    backgroundColor: '#DFF4F2',
    color: '#1F2D3D',
    padding: '6px 10px',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 600,
    fontSize: '14px'
};

const IconDocumento = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='#2AA9A0' className='bi bi-file-earmark-text' viewBox='0 0 16 16'>
        <path d='M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z' />
        <path d='M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z' />
    </svg>
);

const IconLista = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='#2AA9A0' viewBox='0 0 16 16'>
        <rect x='1' y='2' width='14' height='2.5' rx='0.5' />
        <rect x='1' y='6.75' width='14' height='2.5' rx='0.5' />
        <rect x='1' y='11.5' width='14' height='2.5' rx='0.5' />
    </svg>
);

const IconEmbudo = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='currentColor' className='bi bi-funnel' viewBox='0 0 16 16'>
        <path d='M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z' />
    </svg>
);

const IconInfo = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='currentColor' className='bi bi-info-circle' viewBox='0 0 16 16'>
        <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
        <path d='m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z' />
    </svg>
);

const IconFlechaArriba = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' className='bi bi-arrow-up-short' viewBox='0 0 16 16'>
        <path fillRule='evenodd' d='M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z' />
    </svg>
);

const Formulario = ({ row, llaves, antecedentes, asistencias, setAsistencias, recargarDatos, onTareaGestionada, setShowModal }) => {

    const [loading, setLoading] = useState(false);
    const [placaBuscar, setPlacaBuscar] = useState('');
    const [modoFiltro, setModoFiltro] = useState('fecha');
    const [asistenciaSeleccionada, setAsistenciaSeleccionada] = useState(null);
    // v2.1: el caso puede no haber sido informado por Asistencia IKE — el link
    // "Seleccionar sin asistencia preliminar" habilita la Sección 3 sin necesidad de
    // elegir un registro. Mutuamente excluyente con asistenciaSeleccionada.
    const [sinAsistencia, setSinAsistencia] = useState(false);

    const [abogados, setAbogados] = useState([]);
    const [abogadosFiltrados, setAbogadosFiltrados] = useState([]);
    const [buscarAbogadoTexto, setBuscarAbogadoTexto] = useState('');
    const [abogadoSeleccionado, setAbogadoSeleccionado] = useState(null);
    const [avisoAbogado, setAvisoAbogado] = useState('');
    // Id del abogado preseleccionado automáticamente por RN-08/09/10 (coincidencia de nombre con
    // "Abogado Asistencia"). Se limpia en cuanto el usuario elige otro abogado de la lista.
    const [idAbogadoPreseleccionado, setIdAbogadoPreseleccionado] = useState(null);

    const [showToast, setShowToast] = useState(false);
    const [responseData, setResponseData] = useState({});

    const seccionAsignarHabilitada = !!asistenciaSeleccionada || sinAsistencia;

    useEffect(() => {
        setPlacaBuscar(antecedentes?.Patente || '');
    }, [antecedentes]);

    const cargarAbogados = async () => {
        const q = Buffer.from(JSON.stringify({
            idOrganizacion: llaves?.idOrgCaso,
            rol: ROL_ABOGADOS_DEFENSA_PENAL,
            tipoPersona: '0080PROVE00'
        })).toString('base64');
        const lista = await serviceGetAbogadosDefensaPenal(q);
        const ordenada = [...(lista || [])].sort((a, b) => (a.nombre || '').localeCompare(b.nombre || ''));
        setAbogados(ordenada);
        setAbogadosFiltrados(ordenada);
        return ordenada;
    };

    // Selección de un registro de asistencia -> habilita sección "Asignar Abogado"
    // y precarga la lista de abogados con preselección automática (RN-08/09/10).
    const onSelectAsistencia = async (asistencia) => {
        setSinAsistencia(false);
        setAsistenciaSeleccionada(asistencia);
        setAbogadoSeleccionado(null);
        setBuscarAbogadoTexto('');
        setAvisoAbogado('');
        setIdAbogadoPreseleccionado(null);

        setLoading(true);
        try {
            const ordenada = await cargarAbogados();
            const match = ordenada.find((a) => normaliza(a.nombre) === normaliza(asistencia.abogado));
            if (match) {
                setAbogadoSeleccionado(match);
                setIdAbogadoPreseleccionado(match.id);
            } else if (asistencia.abogado) {
                setAvisoAbogado(`El "Abogado Asistencia" (${asistencia.abogado}) no se encuentra en el listado. Seleccione uno manualmente.`);
            }
        } catch (error) {
            console.log('Error al cargar abogados de defensa penal:', error);
        } finally {
            setLoading(false);
        }
    };

    // "Seleccionar sin asistencia preliminar" (v2.1): habilita la Sección 3 sin un
    // registro de asistencia asociado. No hay "Abogado Asistencia" con qué comparar,
    // así que no hay preselección automática (RN-08/09/10 no aplican en este modo).
    const onClickSinAsistencia = async () => {
        setAsistenciaSeleccionada(null);
        setSinAsistencia(true);
        setAbogadoSeleccionado(null);
        setBuscarAbogadoTexto('');
        setAvisoAbogado('');
        setIdAbogadoPreseleccionado(null);

        setLoading(true);
        try {
            await cargarAbogados();
        } catch (error) {
            console.log('Error al cargar abogados de defensa penal:', error);
        } finally {
            setLoading(false);
        }
    };

    const filtrarAbogados = (texto) => {
        setBuscarAbogadoTexto(texto);
        const norm = normaliza(texto);
        setAbogadosFiltrados(abogados.filter((a) => normaliza(a.nombre).includes(norm)));
    };

    const buscarPorPlaca = async () => {
        if (!placaBuscar.trim()) return;
        setLoading(true);
        setAsistenciaSeleccionada(null);
        try {
            const q = Buffer.from(JSON.stringify({ placaBuscar: placaBuscar.trim() })).toString('base64');
            const data = await serviceGetAsistenciasPreliminares(q);
            setAsistencias(data || []);
            setModoFiltro('placa');
        } catch (error) {
            console.log('Error al buscar por placa:', error);
        } finally {
            setLoading(false);
        }
    };

    const limpiarBusqueda = () => {
        setPlacaBuscar(antecedentes?.Patente || '');
        setAsistenciaSeleccionada(null);
        setSinAsistencia(false);
        setModoFiltro('fecha');
        recargarDatos();
    };

    const handleAsignar = async () => {
        if (!abogadoSeleccionado) return;
        setLoading(true);
        try {
            const body = {
                idCaso: llaves?.idCaso,
                idImplicado: row?.idImplicado,
                idOrganizacion: llaves?.idOrgCaso,
                idUsuario: Auth.currentUser().rutUsuario,
                idAsistencia: asistenciaSeleccionada?.idAsistencia || null,
                idAbogado: abogadoSeleccionado.id,
                nombreAbogado: abogadoSeleccionado.nombre,
                idTrxOrigen: row?.idTrxOrigen
            };
            const response = await servicePostAsignaAbogado(body);
            setResponseData(response);
            setShowToast(true);
        } catch (error) {
            setResponseData({ code: -1, message: error.message });
            setShowToast(true);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) {
            setShowModal(false);
            if (onTareaGestionada) onTareaGestionada();
        }
    };

    const volver = () => setShowModal(false);

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Card>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                    Iniciar Gestión Defensa Penal — Asignación de Abogado
                </Card.Header>
                <Card.Body>

                    {/* Sección 1: Antecedentes del Siniestro (solo lectura) */}
                    <div className='mb-2' style={sectionHeaderStyle}><IconDocumento />1. Antecedentes del Siniestro</div>
                    <Container className='mb-3 border pt-2 pb-2'>
                        <Row>
                            <Col md='2'><Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Siniestro</Form.Label><br />{antecedentes?.Siniestro || '—'}</Col>
                            <Col md='2'><Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Placa</Form.Label><br />{antecedentes?.Patente || '—'}</Col>
                            <Col md='2'><Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Marca Vehículo</Form.Label><br />{antecedentes?.Marca || '—'}</Col>
                            <Col md='2'><Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Fecha Siniestro</Form.Label><br />{antecedentes?.FechaSiniestroFormat || '—'}</Col>
                            <Col md='2'><Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Ciudad Siniestro</Form.Label><br />{antecedentes?.ComunaOcurrencia || '—'}</Col>
                            <Col md='2'><Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Departamento</Form.Label><br />{antecedentes?.CiudadOcurrencia || '—'}</Col>
                        </Row>
                    </Container>

                    {/* Sección 2: Asistencias Preliminares */}
                    <div className='mb-2' style={sectionHeaderStyle}><IconLista />2. Asistencias Preliminares</div>
                    <Container className='mb-3 border pt-2 pb-2'>
                        <Row className='g-2 align-items-end mb-2'>
                            <Col md='3'>
                                <Form.Label className='fw-bold mb-1' style={{ fontSize: '13px' }}>Placa</Form.Label>
                                <Form.Control size='sm' value={placaBuscar} maxLength={8}
                                    onChange={(e) => setPlacaBuscar(e.target.value.toUpperCase())} />
                            </Col>
                            <Col md='auto'>
                                <Button size='sm' variant='info' onClick={buscarPorPlaca}>Buscar Placa</Button>
                            </Col>
                            <Col md='auto'>
                                <Button size='sm' variant='outline-secondary' onClick={limpiarBusqueda}>Limpiar</Button>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col>
                                <div className='text-muted d-flex align-items-start' style={{ fontSize: '12px', gap: '6px' }}>
                                    <span className='mt-1'><IconEmbudo /></span>
                                    {modoFiltro === 'placa' ? (
                                        <span>Mostrando resultados de la búsqueda por placa (sin restricción de fecha). Seleccione un registro para asociarlo al caso.</span>
                                    ) : (
                                        <span>
                                            Mostrando registros con CASO = 0 (sin caso asociado) y FECHA dentro de{' '}
                                            {sumarDiasISO(antecedentes?.FechaSiniestroFmt, -1)} – {sumarDiasISO(antecedentes?.FechaSiniestroFmt, 1)}{' '}
                                            (±1 día respecto a la Fecha Siniestro). Seleccione un registro para asociarlo al caso.
                                        </span>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    {/* Bootstrap 5 pinta el fondo de cada celda vía variables CSS
                                        (--bs-table-bg), no hereda el background-color del <thead> */}
                                    <th style={{ ...thAsistenciasStyle, width: '34px' }}></th>
                                    <th style={thAsistenciasStyle}>Fecha</th>
                                    <th style={thAsistenciasStyle}>Ciudad</th>
                                    <th style={thAsistenciasStyle}>Departamento</th>
                                    <th style={thAsistenciasStyle}>Placa</th>
                                    <th style={thAsistenciasStyle}>Exp_Asistencia</th>
                                    <th style={thAsistenciasStyle}>Abogado</th>
                                    <th style={thAsistenciasStyle}>Cuenta</th>
                                    <th style={thAsistenciasStyle}>Servicio</th>
                                    <th style={thAsistenciasStyle}>Teléfono</th>
                                </tr>
                            </thead>
                            <tbody>
                                {asistencias.length === 0 && (
                                    <tr><td colSpan='10' className='text-center text-muted'>No se encontraron asistencias preliminares sin caso asociado.</td></tr>
                                )}
                                {asistencias.map((a) => {
                                    const coincide = antecedentes?.Patente && normaliza(a.placa) === normaliza(antecedentes.Patente);
                                    const seleccionada = asistenciaSeleccionada?.idAsistencia === a.idAsistencia;
                                    // Bootstrap 5 pinta el fondo de cada celda vía variables CSS
                                    // (--bs-table-bg), no hereda el background-color del <tr>
                                    const tdStyle = seleccionada ? { backgroundColor: '#EAF3FB' } : undefined;
                                    return (
                                        <tr key={a.idAsistencia}>
                                            <td className='text-center' style={tdStyle}>
                                                <Form.Check
                                                    type='radio'
                                                    name='rbAsistencia'
                                                    checked={asistenciaSeleccionada?.idAsistencia === a.idAsistencia}
                                                    onChange={() => onSelectAsistencia(a)}
                                                />
                                            </td>
                                            <td style={tdStyle}>{formatearFechaHora(a.fecha)}</td>
                                            <td style={tdStyle}>{a.ciudad}</td>
                                            <td style={tdStyle}>{a.departamento}</td>
                                            <td style={tdStyle}>
                                                {a.placa}
                                                {coincide && (
                                                    <span className='d-inline-flex flex-column ms-1 align-top'>
                                                        <span className='badge bg-success mb-1' style={{ fontSize: '9px' }}>COINCIDE</span>
                                                        <span className='badge bg-success' style={{ fontSize: '9px' }}>PLACA</span>
                                                    </span>
                                                )}
                                            </td>
                                            <td style={tdStyle}>{a.expediente}</td>
                                            <td style={tdStyle}>{a.abogado}</td>
                                            <td style={tdStyle}>{a.cuenta}</td>
                                            <td style={tdStyle}>{a.servicio}</td>
                                            <td style={tdStyle}>{a.telefono}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Container>

                    {/* Sección 3: Asignar Abogado */}
                    <div className='mb-2' style={sectionHeaderStyle}><IconDocumento />3. Asignar Abogado</div>
                    <Container className='mb-2 border pt-2 pb-2'>
                        <Row>
                            <Col md='4'>
                                {sinAsistencia ? (
                                    <div className='bg-light border rounded p-2 text-muted fst-italic'>
                                        Sin asistencia preliminar asociada. Seleccione el abogado a asignar.
                                    </div>
                                ) : !asistenciaSeleccionada ? (
                                    <div className='bg-light border rounded p-3 text-center text-muted fst-italic'>
                                        <div className='mb-1'><IconFlechaArriba /></div>
                                        Seleccione un registro en "Asistencias Preliminares" para continuar.
                                    </div>
                                ) : (
                                    <div className='bg-light border rounded p-2'>
                                        <div className='text-muted' style={{ fontSize: '11px' }}>ABOGADO ASISTENCIA</div>
                                        <div className='fw-bold mb-2'>{asistenciaSeleccionada.abogado || '—'}</div>
                                        <div className='text-muted' style={{ fontSize: '11px' }}>EXP_ASISTENCIA</div>
                                        <div className='fw-bold'>{asistenciaSeleccionada.expediente || '—'}</div>
                                    </div>
                                )}
                            </Col>
                            <Col md='8'>
                                <div className='d-flex justify-content-between align-items-center mb-1'>
                                    <Form.Label className='fw-bold mb-0' style={{ fontSize: '13px' }}>Abogado Asignado</Form.Label>
                                    {!seccionAsignarHabilitada && (
                                        <Button variant='outline-info' size='sm' onClick={onClickSinAsistencia}>
                                            Seleccionar sin asistencia preliminar
                                        </Button>
                                    )}
                                </div>
                                <Form.Control
                                    size='sm'
                                    className='mb-2'
                                    placeholder='Buscar abogado por nombre...'
                                    disabled={!seccionAsignarHabilitada}
                                    value={buscarAbogadoTexto}
                                    onChange={(e) => filtrarAbogados(e.target.value)}
                                />
                                <ListGroup style={{ maxHeight: '260px', overflowY: 'auto' }}>
                                    {abogadosFiltrados.map((a) => {
                                        const seleccionado = abogadoSeleccionado?.id === a.id;
                                        return (
                                            <ListGroup.Item
                                                key={a.id}
                                                action
                                                onClick={() => setAbogadoSeleccionado(a)}
                                                className='d-flex justify-content-between align-items-center'
                                                style={seleccionado ? { backgroundColor: '#EAF3FB' } : undefined}
                                            >
                                                <span className='d-flex align-items-center gap-2'>
                                                    <Form.Check
                                                        type='radio'
                                                        name='rbAbogado'
                                                        checked={seleccionado}
                                                        onChange={() => setAbogadoSeleccionado(a)}
                                                        className='mb-0'
                                                    />
                                                    <span>{a.nombre}</span>
                                                </span>
                                                <span className='text-muted' style={{ fontSize: '11px' }}>{a.id}</span>
                                            </ListGroup.Item>
                                        );
                                    })}
                                </ListGroup>
                                {idAbogadoPreseleccionado && abogadoSeleccionado?.id === idAbogadoPreseleccionado && (
                                    <div className='text-muted mt-1 d-flex align-items-center' style={{ fontSize: '12px', gap: '6px' }}>
                                        <span className='text-warning'><IconInfo /></span>
                                        <span>Preseleccionado automáticamente por coincidir con el "Abogado Asistencia". Puede seleccionar otro abogado de la lista.</span>
                                    </div>
                                )}
                                {avisoAbogado && (
                                    <div className='text-muted mt-1 d-flex align-items-center' style={{ fontSize: '12px', gap: '6px' }}>
                                        <span className='text-warning'><IconInfo /></span>
                                        <span>{avisoAbogado}</span>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Container>

                </Card.Body>
                <Card.Footer>
                    {showToast && (
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={5000}
                            responseData={responseData}
                        />
                    )}
                    <Container>
                        <Row>
                            <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                                <Button className='m-2 w-auto' variant='outline-info' onClick={volver}>Volver</Button>
                                <Button
                                    className='m-2 w-auto'
                                    variant='info'
                                    disabled={!abogadoSeleccionado}
                                    onClick={handleAsignar}
                                >
                                    Asignar
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Card.Footer>
            </Card>
        </Fragment>
    );
};

export default Formulario;
